/**
 * Creates an object composed of the picked object properties.
 * @param {T} obj
 * @param {KeyList} keys
 * @returns {Pick<T extends {}, KeyList extends readonly (keyof T)[]>}
 */
export function pick(obj, ...keys) {
    const result = {};
    keys.forEach((key) => {
        if (!(key in obj)) {
            // We do not want to convert implicit undefined into an explicit one
            return;
        }
        result[key] = obj[key];
    });
    return result;
}
/**
 * Creates an object composed of the object properties the predicate returns true for.
 * @param {T} obj
 * @param {<K extends keyof T>(value: T[K], key: K) => boolean} predicate
 * @returns {Partial<T extends {}>}
 */
export function pickBy(obj, predicate) {
    const result = {};
    Object.keys(obj).forEach((key) => {
        if (predicate(obj[key], key)) {
            result[key] = obj[key];
        }
    });
    return result;
}
/**
 * The opposite of pick.
 * Creates an object composed of all the properties of obj excluding those keys that are passed as arguments.
 * @param {T} obj
 * @param {KeyList} keys
 * @returns {Omit<T, KeyList extends readonly (keyof T)[]>}
 */
export function omit(obj, ...keys) {
    const keysToPick = Object.keys(obj).filter((key) => !keys.some((omitKey) => omitKey === key.toString()));
    return pick(obj, ...keysToPick);
}
//# sourceMappingURL=pick.js.map